import React from "react";
import { Link } from "react-router-dom";

const SummerCampPaymentFailed = () => {
  return (
    <div
      className="bg-custom brightness"
      style={{
        minHeight: "88vh",
        // backgroundColor: "#f8f9fa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        fontFamily: '"Segoe UI", Roboto, sans-serif',
        "--br-value": 1.28,
      }}
    >
      <div
        className="bg-custom brightness"
        style={{
          // background: "white",
          padding: "50px 40px",
          borderRadius: "16px",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
          maxWidth: "500px",
          width: "100%",
          textAlign: "center",
          "--br-value": 1,
        }}
      >
        <div
          style={{
            fontSize: "100px",
            color: "#dc3545",
            marginBottom: "20px",
          }}
        >
          ❌
        </div>

        <h1 className="text-clip" style={{ fontSize: "28px", "--clip-color": "#333", margin: "0 0 16px 0" }}>
          Payment Failed
        </h1>

        <p
          className="text-clip"
          style={{
            "--clip-color": "#666",
            fontSize: "16px",
            lineHeight: "1.6",
            marginBottom: "30px",
          }}
        >
          We're sorry, but your payment could not be processed at this time.
          <br />
          This could be due to insufficient funds, card issues, or a temporary
          system error.
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "20px",
          }}
        >
          <Link to="/summer-camp-checkout">
            <button
              style={{
                padding: "14px 32px",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                width: "100%",
                transition: "background 0.2s",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
            >
              Try Payment Again
            </button>
          </Link>

          <Link to="/cart">
            <button
              style={{
                padding: "14px 32px",
                backgroundColor: "transparent",
                color: "#007bff",
                border: "2px solid #007bff",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                width: "100%",
                transition: "all 0.2s",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#007bff";
                e.target.style.color = "white";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#007bff";
              }}
            >
              Return to Cart
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SummerCampPaymentFailed;
